"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CustomerIdsParams model module.
 * @module model/CustomerIdsParams
 * @version 1.1.3-alpha.1
 */
class CustomerIdsParams {
  /**
   * Constructs a new <code>CustomerIdsParams</code>.
   * @alias module:model/CustomerIdsParams
   */
  constructor() {
    CustomerIdsParams.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>CustomerIdsParams</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CustomerIdsParams} obj Optional instance to populate.
   * @return {module:model/CustomerIdsParams} The populated <code>CustomerIdsParams</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CustomerIdsParams();
      if (data.hasOwnProperty('customer_ids')) {
        obj['customer_ids'] = _ApiClient.default.convertToType(data['customer_ids'], ['String']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CustomerIdsParams</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomerIdsParams</code>.
   */
  static validateJSON(data) {
    // ensure the json data is an array
    if (!Array.isArray(data['customer_ids'])) {
      throw new Error("Expected the field `customer_ids` to be an array in the JSON data but got " + data['customer_ids']);
    }
    return true;
  }
}

/**
 * @member {Array.<String>} customer_ids
 */
CustomerIdsParams.prototype['customer_ids'] = undefined;
var _default = exports.default = CustomerIdsParams;